import initializeHubspotChatWidget from './hubspot_chat_widget';

export const initHubspotChat = () => {
  if (window.hsConversationsSettings) {
    initializeHubspotChatWidget();
  }
};
